import {CSSProperties, FC} from 'react';
import {shallowEqual} from 'react-redux';
import {useAppSelector} from '~/QuickEcards/store';
import {selectBackground, selectFabricArt} from '~/QuickEcards/store/reducers/ecard';
import {Video} from '~library/atoms/Video';

import './ECard.sass';

interface ECardStaticProps {
  src?: string; // Temporary for testing
  hideBackground?: boolean;
}

export const ECardStatic: FC<ECardStaticProps> = ({src = '', hideBackground = false}) => {
  const fabricArt = useAppSelector(selectFabricArt, shallowEqual);
  const background = useAppSelector(selectBackground);
  const templateImage =
    src ||
    fabricArt?.backgroundImage?.src ||
    window.fabricTemplate.editable_art?.default?.backgroundImage?.src;
  const isMp4 = templateImage?.endsWith('mp4');

  const style: CSSProperties | undefined = hideBackground || !background ? undefined : {background};

  return (
    <>
      {hideBackground ? null : <div className="ecard__background" style={style} />}
      <div className="ecard__wrapper ecard__wrapper--static">
        <div className="ecard__content">
          {isMp4 && templateImage ? (
            <Video src={templateImage} className="ecard__front" />
          ) : (
            <img className="ecard__front" src={templateImage} alt="ecard design" />
          )}
        </div>
      </div>
    </>
  );
};
